import React from 'react';
import ProgramsManager from '../Programs/ProgramsManager';
import { PROGRAM_TYPES } from '../../services/programsService';

const IntroToCostingAndManAcc = ({ userRole = 'client' }) => {
  return <ProgramsManager userRole={userRole} programType={PROGRAM_TYPES.COSTING_ACCOUNTING} />;
};

export default IntroToCostingAndManAcc;
